export default __webpack_public_path__ + "static/media/qr-code.5b56db07.svg";